module.exports = __webpack_public_path__ + "img/icon-menu.fa27f31a.png";